import { Injectable } from '@angular/core';
import { StampManagerType } from '@models/imported/SagaBase';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CCaller } from '@models/imported/SagaSchema/CCaller';
import { CFormLink } from '@models/imported/SagaSchema/CFormLink';
import { CPatient } from '@models/imported/SagaSchema/CPatient';
import { CStampCard } from '@models/imported/SagaSchema/CStampCard';
import { ListCardStatus } from '@models/imported/SagaStateLib/ListCardStatus';
import { FetchListService } from '@services/fetchlist/fetchlist.service';
import { IModelService, IObjectChange, ModelService } from '@services/model-factory';

@ModelService(CallCard)
@Injectable()
export class CallcardModelService implements IModelService<CallCard> {
  constructor(private _fetchListService: FetchListService) {}

  public change(change: IObjectChange<CallCard>) {
    const object = change.target;

    if (object.component(CStampCard).length > 0) {
      // Status
      const stamps = object.component<CStampCard>(CStampCard).filter(stamp => stamp.StampType === StampManagerType.Status);
      stamps.sort((a, b) => b.CreatedUTC.getTime() - a.CreatedUTC.getTime());
      if (stamps.length) {
        // Status
        const stamp = stamps[0];
        object.status = this._fetchListService.getRow(ListCardStatus, stamp.Status);
      }
    }

    if (!object.status) {
      object.status = this._fetchListService.getRow(ListCardStatus, 1);
    }

    object.callers = object.component<CCaller>(CCaller).concat([]);
    object.callers.sort((a, b) => b.LineOwner - a.LineOwner);

    object.firstCaller = object.callers.find(caller => caller.IsFirstCaller);

    object.component<CFormLink>(CFormLink).sort((a, b) => a.compare(b));
    object.component<CPatient>(CPatient).sort((a, b) => a.PatientNumber - b.PatientNumber);
  }
}
